module.exports = __webpack_public_path__ + "static/media/customer_Img_Gourment_Biriyani.02bc9d3c.jpeg";